import { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useGetPackagesListQuery } from "../api/games";
import { incrementPackagesPage } from "../redux/gamePackageReducer";

export const usePackagesCatalog = () => {
    const dispatch = useDispatch();

    const page = useSelector((state: any) => state.packages.packagesPage);

    const { data, isFetching } = useGetPackagesListQuery({ page });

    const hasMore = data ? page < data.meta.pageCount : false;

    const loadMore = useCallback(() => {
        if (hasMore && !isFetching) {
            dispatch(incrementPackagesPage());
        }
    }, [hasMore, isFetching, dispatch]);

    return {
        packages: data?.items || [],
        isLoading: isFetching,
        hasMore,
        loadMore
    };
};